import { render, staticRenderFns } from "./OrderPaymentStatusChip.vue?vue&type=template&id=28906739&"
import script from "./OrderPaymentStatusChip.vue?vue&type=script&lang=ts&"
export * from "./OrderPaymentStatusChip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports